var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useReport } from '@tencent/dz-report';
import { useMessageById } from '../../../hooks';
export var useReportService = function (messageId) {
    var report = useReport();
    var messageState = useMessageById(messageId);
    var _a = messageState.msg_content, msgContent = _a === void 0 ? '' : _a;
    var commonReportParams = {
        module_id: '',
        module_value: msgContent,
        module_type: 'message',
        module_chinese_type: '消息',
        element_id: msgContent,
    };
    var quickReplyExposure = function () {
        report.exposure(__assign(__assign({}, commonReportParams), { element_type: 'quick_reply', element_chinese_type: '一键回复', element_content: msgContent }));
    };
    var quickReplyClick = function (answer) {
        report.click(__assign(__assign({}, commonReportParams), { element_type: 'quick_reply_answer', element_chinese_type: '一键回复_回答', element_content: answer }));
    };
    return {
        quickReplyClick: quickReplyClick,
        quickReplyExposure: quickReplyExposure,
        commonReportParams: commonReportParams,
    };
};
